import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import _ from 'lodash';

import PressLogoSalad from '../press-logo-salad/press-logo-salad';
import PressArticle from '../press-article/press-article';
import PressLogoTiles from '../../../lib/company-content-src/press-logo-salad-logos';

const PressCategory = ({ articles, displayLogoSalad }) => {
  const logoSaladBlock = 1;

  return (
    <section
      className={classNames([
        'press-category',
        classes('width-100'),
        classes('margin-top-0'),
        classes('margin-bottom-5'),
        classes('margin-horizontal-auto'),
      ])}
    >
      {_.map(articles, (article, i) => {
        const renderLogoSalad = displayLogoSalad && i === logoSaladBlock;

        return (
          <article className={classNames('press-article__container')} key={i}>
            {renderLogoSalad ? (
              <div>
                <PressArticle key={i} article={article} />
                <PressLogoSalad {...PressLogoTiles} />
              </div>
            ) : (
              <PressArticle key={i} article={article} />
            )}
          </article>
        );
      })}
    </section>
  );
};

PressCategory.propTypes = {
  displayLogoSalad: PropTypes.bool.isRequired,
  articles: PropTypes.array.isRequired,
};

PressCategory.defaultProps = {
  displayLogoSalad: false, // eslint-disable-line react/default-props-match-prop-types
};

PressCategory.displayName = 'PressCategory';

export default PressCategory;
